import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("yt_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const imgSrc = (image) =>
    image && image.startsWith("http") ? image : `${API}/files/${image}`;

export const CONTACT_EMAIL = "kichazone@gmail.com";

export const getVisitorId = () => {
    let vid = localStorage.getItem("yt_visitor_id");
    if (!vid) {
        vid = crypto.randomUUID();
        localStorage.setItem("yt_visitor_id", vid);
    }
    return vid;
};

export const hasConsent = () => localStorage.getItem("yt_consent") === "accepted";

export const trackEvent = (payload) => {
    if (!hasConsent()) return;
    const ref = document.referrer && !document.referrer.includes(window.location.host) ? document.referrer : "";
    api.post("/track", { referrer: ref, visitor_id: getVisitorId(), ...payload }).catch(() => {});
};

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
